import React from "react";
import { Navbar, Container } from "react-bootstrap";

const NavigationBar = () => {
  return (
    <Navbar
      className="position-sticky top-0 fw-bolder mx-5 z-1"
      expand="lg"
      style={{ backgroundColor: "transparent", borderBottom: "3px solid #fff" }}
    >
      <Container>
        <Navbar.Brand className="navbar-brand text-white" href="#home">
          IFMF
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
